import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { reportToSegment, types } from '@smartcar/morse';
import { Box, useTheme } from '@mui/material';

import {
  Login,
  SignUp,
  ForgotPassword,
  ResetPassword,
} from './components';
import { Footer, Header } from '../../components';

const Authentication = () => {
  const theme = useTheme();

  useEffect(() => {
    reportToSegment(types.PAGE, 'Authentication');
  });

  return (
    <Box sx={{
      backgroundColor: theme.palette.background.default,
      minHeight: '100vh',
      maxWidth: '1000px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
    }}
    >
      <Header />
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/signup" component={SignUp} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={ResetPassword} />
        <Redirect to="/login" />
      </Switch>
      <Footer />
    </Box>
  );
};

export default Authentication;
